import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

import { logosQueryKeys } from './query-keys';

type LogosBatchActions = 'delete';

type LogoBatchItem = {
  id: string;
};

export type TBatchLogosParams = {
  action: LogosBatchActions;
  items: LogoBatchItem[];
};

export function batchLogos(body: TBatchLogosParams): Promise<unknown> {
  return mediaManagerClient.post(`/api/v1/logos/batch`, body);
}

type MutationFn = typeof batchLogos;

type UseBatchLogosParams = {
  config?: MutationConfig<MutationFn>;
};

export function useBatchLogos({ config }: UseBatchLogosParams = {}) {
  const { t } = useTranslation();

  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    onError(error) {
      const { status } = parseError(error);

      if (status === 404) {
        addErrorNotification(t('Uno de los logos no existe'));
      } else {
        addErrorNotification(t('No se han podido eliminar los logos'));
        console.error(error);
      }
    },
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: logosQueryKeys.all });
      addSuccessNotification('Los logos se han eliminado correctamente');
    },
    ...config,
    mutationFn: batchLogos,
  });
}
